import _ from 'lodash';
import React from 'react';
import timeBillableTypes from '~/lookups/time-billable-types';
import MultiSelect from '../MultiSelect';

const options = _.values(timeBillableTypes);

export default function TimeBillableTypeFilter({ placeholder = 'Time Type', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
